module.exports = new __parcel__URL__("create-form-background-dark.c55c36dd.png").toString();